module.exports = __webpack_public_path__ + "img/icon-email-light.c091fb7f.svg";